/* Directive */

(function () {
  'use strict';

  /**
   * @author Dahang Xu
   * @description Directive of Semafone CreditCard Validate
   * @class ute-ui
   * @memberOf ute-ui
   */

  angular.module('ute.ui')
    .directive('uteSemafoneValidateCC', ['uteSemafoneService', function (uteSemafoneService) {

      return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {

          ctrl.$validators.format = function (modelVal, viewVal) {

            return ('SUCCESS' === uteSemafoneService.getSemafoneValidationState());

          };
        }
      };
    }]);
})();
